<div class="conatiner-wrapper">
  <div class="header" *ngIf="!showHideSearch">
    <div class="image-logo">
      <a href="./">
        <img class="logo" aria-label="5paisa Logo" alt="5paisa Logo" title="5paisa Logo" src="https://images.5paisa.com/Campaign/5paisa-logo.svg">
      </a>
    </div>

    <h1>{{subCategoryName}}</h1>
    <div class="header-image-wrapper">
      <button type="button" class="search-toggle-btn" (click)="changeHeader()" aria-label="Open FAQ search">
        <span class="icon-search" aria-hidden="true"></span>
      </button>
      <!-- <img src="https://images.5paisa.com/forum/icon-language.png" /> -->
    </div>

  </div>
  <div class="header-search-bar" *ngIf="showHideSearch">
    <div class="form-tab">
      <!-- <img (click)="goBack()" src="https://images.5paisa.com/forum/icon-left-arrow.svg" /> -->
      <div class="search-field d-flex position-relative w-100">
        <span class="icon-search" aria-hidden="true"></span>
        <form [formGroup]="searchForm" novalidate>
          <label for="subcategory-search-input" class="visually-hidden">Search for your questions</label>
          <input autocomplete="off" type="text" pattern="^[a-zA-Z0-9?]*$" name="search" id="subcategory-search-input" class="text-field"
            placeholder="Search for FAQs" formControlName="searchText" (keyup)="searchByString()" (keypress)="omit_special_char($event)"
            role="combobox"
            aria-autocomplete="list"
            [attr.aria-expanded]="showResults"
            aria-controls="subcategory-search-results"
            (keydown)="onSearchInputKeydown($event)"/>
          <ul id="subcategory-search-results" class="results" *ngIf="showResults && searchListArray.length" role="listbox" aria-label="Search results">
            <li *ngFor="let item of searchListArray; index as i" role="option">
              <button type="button"
                class="result-item"
                *ngIf="isSearchResultItem(item)"
                [attr.id]="'subcategory-search-result-' + i"
                (click)="goTosubCategoryAnswers(item.id, item.category.id, item.permalink, item.title)"
                (keydown)="onResultKeydown($event, i)">
                {{ item.title }}
              </button>
              <span *ngIf="item === constantService.noResultFoundText" class="result-empty">{{ item }}</span>
            </li>
          </ul>
        </form>
      </div>
      <button type="button" class="icon-cross-btn" (click)="closeSearchBar()" aria-label="Close search"></button>
    </div>
  </div>



  <div class="faq-details-section" *ngIf="!showLoader">
    <h2>
      {{answer.title}}
    </h2>

    <p style="overflow: scroll; scroll-behavior: smooth; scrollbar-width: none;" [innerHtml]="summeryAnswer"></p>
    <hr>
<!-- 
    <p class="text-left">Updated: {{convertedDate}}</p>
    <hr> -->
    <div class="like-dislike-wrapper">
      <span id="article-feedback-label">Was this article helpful?</span>
      <div class="icon-wrapper" role="group" aria-labelledby="article-feedback-label">
        <button type="button"
          class="feedback-btn like-btn"
          [class.active]="likeTrue"
          [attr.aria-pressed]="likeTrue === true"
          [attr.aria-label]="likeTrue ? 'Like this article, selected' : 'Like this article'"
          (click)="likeArticle(answer.id)">
          <span [ngClass]="likeTrue == true ? 'icon-liked' : 'icon-like'" aria-hidden="true"></span>
          <span>Like</span>
        </button>

        <button type="button"
          class="feedback-btn dislike-btn"
          [class.active]="disLikeTrue"
          [attr.aria-pressed]="disLikeTrue === true"
          [attr.aria-label]="disLikeTrue ? 'Dislike this article, selected' : 'Dislike this article'"
          (click)="disLikeArticle(answer.id)">
          <span [ngClass]="disLikeTrue == true ? 'icon-disliked' : 'icon-dislike'" aria-hidden="true"></span>
          <span>Dislike</span>
        </button>
      </div>
      <div class="visually-hidden" aria-live="polite" aria-atomic="true" role="status">
        {{ feedbackStatusMessage }}
      </div>
    </div>

    <div class="create-ticket-wrapper">
      <h3 class="main-heading">Still Stuck?</h3>
      <h4 class="sub-heading">Have you tried looking for an answer?</h4>
      <p>
        Create a ticket and we will respond as soon as possible, or you can
        return later.
      </p>
      <div class="row-wrapper">
        <div class="ticket-button-wrapper">
          <button class="primary-btn" (click)="goToCreateTicket()">Create a Ticket</button>
          <!-- <button class="transparent-btn">Or contact our support</button> -->
          <button class="transparent-btn" (click)="letsChat()">or Chat with us</button>
        </div>
        <div class="phone-icon-container">
          <a href="tel:8976689766"
            class="phone-icon"
            aria-label="Call 5paisa support team at 89766 89766. Available Monday to Friday 8:30 AM to 6:00 PM, Saturday 9:30 AM to 3:30 PM">
            <img class="" src="https://images.5paisa.com/forum/Call.png" alt="" aria-hidden="true"/>
          </a>
        </div>
      </div>
    </div>

  </div>

  <app-loader *ngIf="showLoader"></app-loader>

</div>